export interface IconImotaProps {
  width?: number;
}

export const IconImota = (props: IconImotaProps) => {
  const { width } = props;
  return <img src="/imota-small-icon.svg" alt="Imota" width={width || 100} />;
};
